import type { MailboxInfo } from "owa-client-types";
import type { TokenResponseExtended as TokenResponse } from "owa-service/lib/tokenResponseExtended";
import type { silentlyGetStrongConsumerAuthFunc } from "owa-auth-callbacks";
import { SA_20MIN_SCOPE } from "owa-tokenprovider-utils";
import { getDelegationTokenForOwa } from "./getDelegationToken";
import type TokenResponseCode from "owa-service/lib/contract/TokenResponseCode";
import type { AuthTokenResponse } from "./schema/AuthTokenResponse";

/**
 * Tries to silently get an access token based on the information in targets.
 * @param action. A helpful string, like the one passed to makeServiceRequest, to help identify the context of the request.
 * @param mailboxInfo. Mailbox context to use for this resource token request.
 */
export const silentlyGetStrongConsumerAuth: silentlyGetStrongConsumerAuthFunc = async function (action: string, mailboxInfo: MailboxInfo): Promise<TokenResponse | undefined> {
    if (!action) {
        throw new Error("Action must be provided for proper attribution.");
    }
    
    const consumerToken = (await getDelegationTokenForOwa(SA_20MIN_SCOPE, action, undefined /* requestId */, true /* showFullTokenResponse */, mailboxInfo)) as AuthTokenResponse;
    
    if (!consumerToken) {
        return undefined;
    }
    
    const responseCode: TokenResponseCode | undefined = consumerToken.accessToken
        ? 0 : 3;
    
    return {
        TokenResultCode: responseCode,
        AccessToken: consumerToken.accessToken,
        AccessTokenExpiry: consumerToken.accessTokenExpiry,
        ExpiresIn: consumerToken.expiresIn,
        SubErrorCode: consumerToken.error?.subErrorCode,
    };
};
